document.addEventListener('DOMContentLoaded', function () {
  // Guard so the listener won't be installed twice if the script executes more than once
  if (window._nostoBundleAtcListenerInstalled) {
    console.log('nosto: ATC listener already installed, skipping.');
    return;
  }
  window._nostoBundleAtcListenerInstalled = true;

  const CCART_SELECTOR = '.js-drawer-open-cart';

  function checkNostoList() {
    var nostoList = document.querySelector('.template-product .nosto-list');
    if (!nostoList) {
      setTimeout(checkNostoList, 100);
      return;
    }

    // hide initially and show on flickity ready
    nostoList.style.visibility = 'hidden';
    nostoList.addEventListener('ready.flickity', function () {
      nostoList.style.visibility = 'visible';
    });

    console.log('nosto: list found');
  }

  function bundleAddToCart(quantity, variantId, sourceBtn) {
    if (!variantId) return;

    // mark button busy
    if (sourceBtn) {
      sourceBtn.disabled = true;
      sourceBtn.classList.add('is-busy');
    }

    let data = {
      items: [{ id: variantId, quantity: quantity }]
    };

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
      .then(response => {
        document.dispatchEvent(new Event('cart:build'));
        if (!document.querySelector('#cnv-cart-popup-style')) {
  const style = document.createElement('style');
  style.id = 'cnv-cart-popup-style';
  style.textContent = `
    .cnv-cart-popup {
      position: fixed;
      top: 20px;
      right: 20px;
      background: #fff;
      border: 1px solid #ddd;
      box-shadow: 0 4px 16px rgba(0,0,0,0.15);
      border-radius: 4px;
      padding: 12px;
      max-width: 300px;
      z-index: 9999;
      display: none;
      opacity: 0;
      transition: opacity 0.3s ease, transform 0.3s ease;
      transform: translateY(-10px);
      font-family: inherit;
    }
    .cnv-cart-popup.show {
      display: block;
      opacity: 1;
      transform: translateY(0);
    }
    .cnv-cart-popup img {
      width: 60px;
      height: auto;
      float: left;
      margin-right: 10px;
      border-radius: 2px;
    }
    .cnv-cart-popup .details {
      overflow: hidden;
      font-size: 12px;
    }
    .cnv-cart-popup .title {
      font-weight: 400;
      margin-bottom: 4px;
    }
    .cnv-cart-popup .checkout-btn {
      display: block;
      text-align: center;
      margin-top: 10px;
      background: #000;
      color: #fff;
      padding: 10px;
      font-weight: 600;
      text-decoration: none;
    }
    .cnv-cart-popup .close-btn {
      position: absolute;
      top: 8px;
      right: 8px;
      background: none;
      border: none;
      font-size: 18px;
      line-height: 1;
      cursor: pointer;
      color: #999;
      padding: 4px;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .cnv-cart-popup .close-btn:hover {
      color: #333;
    }
  `;
  document.head.appendChild(style);
}

// Create popup container
const popup = document.createElement('div');
popup.className = 'cnv-cart-popup';
document.body.appendChild(popup);

// Function to close popup
function closePopup() {
  popup.classList.remove('show');
  setTimeout(() => (popup.style.display = 'none'), 300);
}

// Function to build and show popup
fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
  .then(r => r.json())
  .then(cart => {
    if (!cart || !cart.items?.length) return;
    const item = cart.items[0]; // Most recent item (Shopify adds newest first)

    popup.innerHTML = `
      <button class="close-btn" aria-label="Close">×</button>
      <div class="details">
        <div class="title">${item.product_title} zum Warenkorb hinzugefügt</div>
      </div>
    `;

    // Add click handler to close button
    popup.querySelector('.close-btn').addEventListener('click', closePopup);

    popup.style.display = 'block';
    requestAnimationFrame(() => popup.classList.add('show'));

    // Auto-hide after 5s
    setTimeout(closePopup, 5000);
  })
  .catch(console.error);
        // slight delay to avoid strange re-entrancy if click listeners act on cart open
        setTimeout(() => {
          const ccart = document.querySelector(CCART_SELECTOR);
          // if (ccart) ccart.click();
        }, 50);
        return response.json();
      })
      .catch(error => {
        console.error('nosto bundle add error:', error);
      })
      .finally(() => {
        if (sourceBtn) {
          sourceBtn.disabled = false;
          sourceBtn.classList.remove('is-busy');
          delete sourceBtn.dataset.nostoProcessing;
        }
      });
  }

  // Delegated click handler (installed once)
  document.addEventListener('click', function (e) {
    const button = e.target.closest('.nosto-bundle-list-item .btn--full.add-to-cart');
    if (!button) return;

    // Per-button quick-guard: ignore if already processing
    if (button.dataset.nostoProcessing === '1') {
      console.log('nosto: ignored duplicate/rapid click for same button');
      return;
    }
    button.dataset.nostoProcessing = '1';
    // fallback: clear guard after 2s in case something goes wrong
    setTimeout(() => { if (button) delete button.dataset.nostoProcessing; }, 2000);

    // Debug traces so you can see the stack and timestamp for each invocation
    console.log('BUNDLE ATC CLICKED', new Date().toISOString(), button);
    console.trace();

    const parent = button.closest('.nosto-bundle-list-item');
    const optionSelect = parent && parent.querySelector('.bundle-options');
    let variantId = optionSelect ? optionSelect.value : null;

    if (!variantId) {
      const sizeInput = parent.querySelector('.nosto-bundle-sizes-container input:checked, .nosto-bundle-sizes-container input');
      variantId = sizeInput ? sizeInput.value : null;
    }

    if (variantId) {
      bundleAddToCart(1, variantId, button);
    } else {
      // clear guard if we didn't actually add
      delete button.dataset.nostoProcessing;
    }
  });

  checkNostoList();
});
